export const SET_SEARCH_PARAMS = 'set_search_params'
export const SET_INVENTORY_ACTION_STATES = 'set_inventory_action_states'
